import _asyncToGenerator from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["collectorUrl"];
import _regeneratorRuntime from "/root/code/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { enableFormTracking, FormTrackingPlugin } from "@snowplow/browser-plugin-form-tracking";
import { GaCookiesPlugin } from "@snowplow/browser-plugin-ga-cookies";
import { LinkClickTrackingPlugin, trackLinkClick } from "@snowplow/browser-plugin-link-click-tracking";
import { TimezonePlugin } from "@snowplow/browser-plugin-timezone";
import { enableActivityTracking, newTracker, trackPageView, trackStructEvent } from "@snowplow/browser-tracker";
import debounce from "lodash.debounce";
import { getCLS, getFCP, getFID, getLCP, getTTFB } from "web-vitals";
import loggy from "@catchoftheday/loggy";
import { isAndroidHybridApp, isMobileUA, parseQueryString, sessionStorage } from "@catchoftheday/utilities";
import { SNOWPLOW_SESSION_ID } from "@analytics/consts";
import { subscribeToPathname } from "../../utilities";
import { spContext } from "./context-api";
import { onDOMNodeAdded } from "./onDOMNodeAdded";
var initialized = false; // Respect legacy snowplow config whenever available

var webSnowplowConfig = true && window !== null && "snowplowOptions" in window && window.snowplowOptions || {};
var TRACK_LINK_BLACKLIST = ["js-dnt", "js-product-link"];
export function enableLinkTracking() {
  function linkHandler(event) {
    var target = event.target;
    var anchor = target === null || target === void 0 ? void 0 : target.closest("a");

    if (!anchor) {
      return;
    }

    var targetUrl = anchor.href;
    var elementId = anchor.id;
    var elementClasses = Array.from(anchor.classList);
    var elementTarget = anchor.target;
    var elementContent = anchor.innerHTML;

    if (elementClasses.every(function (className) {
      return !TRACK_LINK_BLACKLIST.includes(className);
    })) {
      trackLinkClick({
        targetUrl: targetUrl,
        elementTarget: elementTarget,
        elementId: elementId,
        elementContent: elementContent,
        elementClasses: elementClasses
      });
    }
  }

  document.body.addEventListener("click", linkHandler);
  return function () {
    return document.body.removeEventListener("click", linkHandler);
  };
}

function getAppId() {
  return isMobileUA() ? "catch_mobile" : "catch";
}

var getPlatform = function getPlatform() {
  return isAndroidHybridApp() ? "srv" : isMobileUA() ? "mob" : "web";
};

export function initialize(_ref) {
  var _ref$disableAutomatic = _ref.disableAutomaticTracking,
      disableAutomaticTracking = _ref$disableAutomatic === void 0 ? false : _ref$disableAutomatic,
      _ref$snowplowConfig = _ref.snowplowConfig,
      collectorUrl = _ref$snowplowConfig.collectorUrl,
      snowplowConfig = _objectWithoutProperties(_ref$snowplowConfig, _excluded);

  if (initialized) {
    return function () {
      return undefined;
    };
  }

  if (false) {
    return;
  }

  var clientConfig = {
    platform: getPlatform(),
    appId: getAppId()
  };
  initialized = true;
  var sp = newTracker("co", collectorUrl, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, snowplowConfig), webSnowplowConfig), clientConfig), {}, {
    discoverRootDomain: parseQueryString(location.search).discoverRootDomain !== "off",
    plugins: [TimezonePlugin(), GaCookiesPlugin(), LinkClickTrackingPlugin(), FormTrackingPlugin()]
  }));
  var domainUserInfo = sp.getDomainUserInfo(); // The sessionId is the 6th item in the domainUserInfo array as per the snowplow docs:
  // https://docs.snowplow.io/docs/collecting-data/collecting-from-own-applications/javascript-trackers/browser-tracker/browser-tracker-v3-reference/advanced-usage/tracker-information/#getdomainuserinfo

  var sessionId = domainUserInfo[6];

  if (sessionId) {
    sessionStorage.setItem(SNOWPLOW_SESSION_ID, sessionId);
    window.dispatchEvent(new StorageEvent("storage", {
      key: SNOWPLOW_SESSION_ID,
      newValue: sessionId
    }));
  }

  if (disableAutomaticTracking) {
    return function () {
      return undefined;
    };
  } // ========================
  // Setup Automatic Trackers
  // ========================


  enableActivityTracking({
    minimumVisitLength: 15,
    heartbeatDelay: 15
  });
  var cleanupLinkTracking = enableLinkTracking();
  var cleanupFormTracking = initializeFormTracking(); // Fire page view when page loads

  triggerPageView(location.pathname, location.search); // Fire page view whenever the pathname changes

  subscribeToPathname(function (pathname) {
    triggerPageView(pathname);
  });
  reportWebVitals();
  return function () {
    cleanupLinkTracking();
    cleanupFormTracking();
  };
}

function triggerPageView(_x, _x2) {
  return _triggerPageView.apply(this, arguments);
}

function _triggerPageView() {
  _triggerPageView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pathname, queryString) {
    var res, contexts;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return spContext(pathname, queryString);

          case 2:
            res = _context.sent;

            if (!(res === null)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            contexts = res.contexts;
            trackPageView({
              context: contexts
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _triggerPageView.apply(this, arguments);
}

function reportWebVitals() {
  function reportVitals(data) {
    trackStructEvent({
      category: "Performance Metrics",
      action: data.name,
      value: data.value
    });
  }

  getCLS(reportVitals);
  getFID(reportVitals);
  getFCP(reportVitals);
  getLCP(reportVitals);
  getTTFB(reportVitals);
}

var FORM_ELEMENTS = ["form", "input", "select", "textarea", "option", "datalist"];
/**
 * Setups snowplow form tracking. Works by calling `enableFormTracking` from snowplow whenever a new form or field is added to the DOM.
 */

function initializeFormTracking() {
  try {
    var trackForms = debounce(function () {
      enableFormTracking({
        options: {
          forms: {
            denylist: ["cc-save-card", "account-save-card", "buy-form", "form-cart-add"]
          }
        }
      });
    }, 1000);
    trackForms();
    return onDOMNodeAdded({
      elements: FORM_ELEMENTS,
      callback: trackForms
    });
  } catch (e) {
    loggy.error(e);
    return function () {
      return undefined;
    };
  }
}